module.exports = __webpack_public_path__ + "a413a3616bb8d63534204ab5644168e7.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1month_show_labels.png
// module id = 883
// module chunks = 7